// Hakkimizda sertifika kartlarindaki yarim kubbe ikonlar (ISO 9001/14001/45001/50001).
export type CertificateTheme = 'red' | 'green' | 'yellow' | 'gray';

const DOME_COLORS: Record<CertificateTheme, string> = {
  red: '#d7342e',
  green: '#5bae36',
  yellow: '#f2b11b',
  gray: '#8a93a0',
};

function DomeSymbol({ theme, color }: { theme: CertificateTheme; color: string }) {
  if (theme === 'red') {
    return (
      <path
        d="M70 70 L92 88 L130 48"
        fill="none"
        stroke="#fff"
        strokeWidth="14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  }

  if (theme === 'green') {
    return (
      <>
        <path d="M72 96 C70 66 96 46 134 48 C136 80 112 96 80 96 Z" fill="#fff" />
        <path
          d="M78 92 C94 78 110 64 126 54"
          fill="none"
          stroke={color}
          strokeWidth="5"
          strokeLinecap="round"
        />
      </>
    );
  }

  if (theme === 'yellow') {
    return (
      <>
        <path d="M66 86 C66 60 82 44 100 44 C118 44 134 60 134 86 Z" fill="#fff" />
        <rect x="93" y="44" width="14" height="28" rx="4" fill={color} />
        <rect x="96" y="47" width="8" height="22" rx="3" fill="#fff" />
        <rect x="56" y="84" width="88" height="10" rx="5" fill="#fff" />
      </>
    );
  }

  return (
    <>
      <path d="M77 60 A24 24 0 0 1 118 51" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
      <path d="M113 44 L122 53 L110 56 Z" fill="#fff" />
      <path d="M123 76 A24 24 0 0 1 82 85" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
      <path d="M87 92 L78 83 L90 80 Z" fill="#fff" />
      <path d="M104 50 L88 72 L99 72 L94 88 L112 64 L101 64 Z" fill="#fff" />
    </>
  );
}

export function CertificateDomeIcon({ theme }: { theme: CertificateTheme }) {
  const color = DOME_COLORS[theme];
  return (
    <svg viewBox="0 0 200 104" aria-hidden="true">
      <line x1="14" y1="101" x2="186" y2="101" stroke={color} strokeWidth="3" strokeLinecap="round" />
      <path d="M30 100 A70 70 0 0 1 170 100 Z" fill={color} />
      <DomeSymbol theme={theme} color={color} />
    </svg>
  );
}
